import { memo } from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import useOneRepMaxChartLines from "../useOneRepMaxChartLines";
import { OneRepMaxChartHeaderEntries, OneRepMaxChartHeaderRoot } from "./OneRepMaxChartHeader.components";
import OneRepMaxChartHeaderEntry from "./components/OneRepMaxChartHeaderEntry";

function OneRepMaxChartHeader() {
  const { t } = useTranslation();
  const { entries } = useOneRepMaxChartLines();

  if (!entries.length) return null;

  return (
    <OneRepMaxChartHeaderRoot>
      <Typography sx={{ fontWeight: "fontWeightMedium", color: "grey.120" }}>
        {t("charting.one_rep_max_tooltip_source", { context: entries[0].last.metadataType })}
      </Typography>
      <OneRepMaxChartHeaderEntries>
        {entries.map((entry) => (
          <OneRepMaxChartHeaderEntry key={entry.variant ?? "bilateral"} entry={entry} />
        ))}
      </OneRepMaxChartHeaderEntries>
    </OneRepMaxChartHeaderRoot>
  );
}

export default memo(OneRepMaxChartHeader);
